import qs from 'qs';
import axios from 'axios';
import get from 'lodash/get';
import { getInstance as getBootstrap } from 'utils/bootstrap';

/**
 * Format the data being set to type URLSearchParamsSubmit and
 * send the form data to the given url.
 * Returns a promise.
 * @param  {string} rsvpUrl - url to the endpoint where the form is being submitted.
 * @param  {Object} params - { [nodeName]: value], ... }
 * @param  {string} requestType - request method, POST by default.
 * @return {Promise}
 */
const submitFormData = (rsvpUrl, params, requestType) => {
    const bootstrap = getBootstrap();
    const previousRequestHash = bootstrap.get('previousRequestHash', null);

    return axios({
        method: requestType,
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify({
            ...params,
            hash: get(window, 'splash.server.constants.ticketHash'),
            previousRequestHash,
        }),
        url: rsvpUrl,
    }).then((response) => response.data);
};

export const submitNewRsvp = (rsvpUrl, params) => submitFormData(rsvpUrl, params, 'POST');

export const submitUpdatedRsvp = (rsvpUrl, params, guestAccessHash) => {
    const hasParams = rsvpUrl.includes('?');
    const queryParams = `guest-access-hash=${guestAccessHash}&modify-registration=1`;

    const submitUrl = `${rsvpUrl}${hasParams ? '&' : '?'}${queryParams}`;

    return submitFormData(submitUrl, params, 'PUT');
};
